/* eslint-disable react-compiler/react-compiler */
import { AutocompleteOption, useAutocomplete } from '@/common/presentation/hooks/useAutocomplete';

import { useListAvailableExtraSystemsQuery } from '@/common/infrastructure/gql/generated/schema';

type ExtraSystem = NonNullable<
  NonNullable<NonNullable<ReturnType<typeof useListAvailableExtraSystemsQuery>['data']>['extraSystems']>['items']
>[number];

export const useListAvailableExtraSystemsAutocomplete = (
  searchTerm: string = '',
  debounceMs: number = 1000,
  onExtraSystemsSelect?: (extraSystem: AutocompleteOption) => void,
  take: number = 10
) => {
  return useAutocomplete<ExtraSystem>({
    searchTerm,
    debounceMs,
    onSelect: onExtraSystemsSelect,
    query: (search?: string) => {
      const { data, loading, error } = useListAvailableExtraSystemsQuery({
        variables: {
          skip: 0,
          take,
          where: search
            ? {
                name: {
                  contains: search
                }
              }
            : undefined
        },
        fetchPolicy: 'cache-first'
      });
      return {
        data: { items: data?.extraSystems?.items },
        loading: loading,
        error: error ?? null
      };
    },
    transform: (extraSystem) => ({
      value: extraSystem.id ?? -1,
      label: extraSystem.name ?? 'Unknown Extra System'
    })
  });
};
